import { useNavigate, useSearchParams } from 'react-router-dom';
import { useBudgets, useCreateBudget } from '@/hooks/useBudgets';
import { BudgetForm } from '@/components/budget/BudgetForm';
import type { CreateBudgetRequest } from '@/types';
import { Page } from '@/components/layout/Page';

export function NewBudgetPage() {
  const navigate = useNavigate();
  const { data: budgets = [] } = useBudgets();
  const createBudget = useCreateBudget();
  const [searchParams] = useSearchParams();
  const parentId = searchParams.get('parentId') ?? '';

  const handleSubmit = async (data: CreateBudgetRequest) => {
    const createdBudget = await createBudget.mutateAsync(data);
    const targetParentId = createdBudget.parentId ?? data.parentId;

    if (targetParentId) {
      navigate(`/budgets/${targetParentId}`);
      return;
    }

    navigate('/budgets');
  };

  const handleCancel = () => {
    navigate(-1);
  };

  // Filter to only top-level budgets for parent selection
  const parentBudgets = budgets;

  return (
    <Page className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Create Budget</h1>
        <p className="text-sm text-muted-foreground">
          Set up a new budget to track your spending
        </p>
      </div>

      <BudgetForm
        parentBudgets={parentBudgets}
        initialParentId={parentId}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        isLoading={createBudget.isPending}
      />
    </Page>
  );
}
